import React from "react";
import { Mail, UserPlus, FileText, CalendarCheck, BadgeCheck, ChevronRight } from "lucide-react";

const STAGES = [
  { key: "emails", label: "Emails Sent", icon: Mail, color: "from-orange-500 to-orange-600" },
  { key: "registrations", label: "Registrations", icon: UserPlus, color: "from-sky-500 to-sky-600" },
  { key: "applications", label: "Applications", icon: FileText, color: "from-indigo-500 to-indigo-600" },
  { key: "interviews", label: "Interviews", icon: CalendarCheck, color: "from-amber-500 to-amber-600" },
  { key: "hires", label: "New Hires", icon: BadgeCheck, color: "from-emerald-500 to-emerald-600" },
];

export const HiringFunnel = ({ metrics, onPick, active }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4 sm:p-5" data-testid="hiring-funnel">
    <div className="flex items-center justify-between mb-3">
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">Hiring success</p>
      <p className="text-xs text-slate-400">Click a stage to see who's in it</p>
    </div>
    <div className="flex flex-col md:flex-row md:items-stretch gap-2">
      {STAGES.map((s, i) => {
        const Icon = s.icon;
        const prev = i > 0 ? metrics?.[STAGES[i - 1].key] : null;
        const val = metrics?.[s.key] ?? 0;
        const rate = prev && val <= prev ? Math.round((val / prev) * 100) : null;
        return (
          <React.Fragment key={s.key}>
            <button onClick={() => onPick(s.key)} data-testid={`funnel-${s.key}`}
              className={`flex-1 rounded-xl bg-gradient-to-br ${s.color} text-white px-4 py-3 text-left shadow-sm transition-transform duration-200 hover:-translate-y-0.5 ${active === s.key ? "ring-4 ring-offset-2 ring-slate-300" : ""}`}>
              <div className="flex items-center gap-2 text-white/85 text-xs font-medium"><Icon className="w-4 h-4" />{s.label}</div>
              <div className="flex items-end justify-between mt-1">
                <span className="text-3xl font-bold tabular-nums" data-testid={`funnel-${s.key}-count`}>{val}</span>
                {rate !== null && <span className="text-[11px] text-white/80 mb-1">{rate}% of prior</span>}
              </div>
              {s.key === "interviews" && metrics?.interviews_scheduled > 0 && <p className="text-[11px] text-white/80">{metrics.interviews_scheduled} upcoming</p>}
            </button>
            {i < STAGES.length - 1 && <ChevronRight className="hidden md:block self-center w-5 h-5 text-slate-300 shrink-0" />}
          </React.Fragment>);
      })}
    </div>
  </div>
);
